module.exports = __webpack_public_path__ + "static/media/super-premium.ce112a38.svg";